export class Language {
  shopKey: string;
  iso: string;
  displayName: string;

  constructor(shopKey: string, iso: string, displayName: string) {
    this.shopKey = shopKey;
    this.iso = iso;
    this.displayName = displayName;
  }
}
